module.exports = __webpack_public_path__ + "img/coingecko1.b13d7e98.png";